document.addEventListener('DOMContentLoaded', function () {
  // console.log('🚀 Script Loaded');
  initializeCartListeners(); // Initial setup
  initializeDeleteListeners();

  // MutationObserver to watch for changes in the cart
  const targetNode = document.querySelector('.cart-container') || document.body;

if (targetNode) {
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        // console.log('🔄 DOM Updated - Reinitializing Listeners');
        initializeCartListeners(); // Reattach listeners
      }
    }
  });

  observer.observe(targetNode, {
    attributes: true,
    childList: true,
    subtree: true,
  });
} else {
  console.error('❗️ Cart container not found. MutationObserver not started.');
}


  // Function to initialize quantity change listeners
  function initializeCartListeners() {
    const quantityInputs = document.querySelectorAll('.cart-quantity-input');
    quantityInputs.forEach(function (input) {
      input.removeEventListener('change', handleQuantityChange);
      input.addEventListener('change', handleQuantityChange);
    });
  }

  // Handle Quantity Change and Update Cart
  function handleQuantityChange(event) {
    const input = event.target;
    const variantId = input.getAttribute('data-variant-id');
    const newQuantity = parseInt(input.value, 10);

    if (!variantId) {
      console.error('Variant ID not found or invalid.');
      return;
    }

    // Update the cart via AJAX
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: newQuantity,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
        return response.json();
      })
      .then(function (cart) {
        // console.log('✅ Updated cart data:', cart);
        updateProgressBar(cart); // Update progress bars dynamically
      })
      .catch(function (error) {
        console.error('❌ Error updating cart:', error);
      });
  }

  function initializeDeleteListeners() {
    const deleteButtons = document.querySelectorAll("cart-remove-button a");
    console.log(deleteButtons);
    deleteButtons.forEach(function (button) {
        button.removeEventListener("click", handleItemDelete);
        button.addEventListener("click", handleItemDelete);
    });
  }

  // Update Progress Bars and Messages Dynamically
  function updateProgressBar(cart) {
    // console.log('🔄 Updating Progress Bars');
    const progressBarElement = document.getElementById('progress-bar');
    const progressBarShipping = document.querySelector('.progress-bar.shipping .progress-bar-done');
    const progressBarDiscount = document.querySelector('.progress-bar.discount .progress-bar-done');
    const shippingMessage = document.querySelector('.shipping-message');
    const discountMessage = document.querySelector('.discount-message');
    const freeShippingIcon = document.querySelector('.free-shipping-icon');
    const discountIcon = document.querySelector('.discount-icon');

    if (!progressBarElement) {
      console.error('❗️ progressBarElement not found. Skipping update.');
      return;
    }

    // Retrieve necessary values
    const shippingValue = parseInt(progressBarElement.dataset.shipping);
    const discountThreshold = parseInt(progressBarElement.dataset.discount);
    const discountPercentage = parseInt(progressBarElement.dataset.percentage);
    const cartTotal = cart.total_price;
    const shippingValueLeft = shippingValue - cartTotal;
    const discountValueLeft = discountThreshold - cartTotal;

    // Progress bar percentages
    const shippingPercentageFraction = (cartTotal * 100) / shippingValue;
    const discountPercentageFraction = (cartTotal * 100) / discountThreshold;

    // Update Progress Bars and Messages
    if (shippingValueLeft > 0) {
      shippingMessage.innerHTML = `📢 You are <strong>${formatMoney(shippingValueLeft)}</strong> away from free shipping!`;
    } else {
      shippingMessage.innerHTML = `🎉 Hurrah! You are eligible for free shipping now.`;
    }

    if (shippingValueLeft <= 0 && discountThreshold > 0) {
      if (discountValueLeft > 0) {
        discountMessage.innerHTML = `🎉 You are <strong>${formatMoney(discountValueLeft)}</strong> away from a ${discountPercentage}% discount!`;
      } else {
        discountMessage.innerHTML = `🎉 Congratulations! You’ve unlocked a ${discountPercentage}% discount!`;
      }
    }

    // Update Progress Bar Widths
    if (progressBarShipping) {
      progressBarShipping.style.width = Math.min(shippingPercentageFraction, 100) + '%';
    }
    if (progressBarDiscount) {
      progressBarDiscount.style.width = Math.min(discountPercentageFraction, 100) + '%';
    }

    // Show Icons When Goals Are Reached
    freeShippingIcon.classList.toggle('icon-visible', shippingValueLeft <= 0);
    discountIcon.classList.toggle('icon-visible', discountValueLeft <= 0);
  }

  // Helper Function: Format Money
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
});
